import clsx from 'clsx';
import { Link } from 'react-router';
import { visibleTabs, type NavSection } from '../lib/nav';

/**
 * Tab bar of a menu section ("Freigaben": Zeiten | Abwesenheitsanträge). The tabs are pages of their own (own address, back
 * button works), shown together under one heading so that related pages are one click apart.
 * A section with one visible tab shows no bar.
 */
export function SectionTabBar({ section, activeTo }: { section: NavSection; activeTo: string }) {
  const tabs = visibleTabs(section);
  if (tabs.length < 2) return null;
  return (
    <nav className="scroll-x flex gap-1 border-b border-line bg-sheet px-4 sm:px-6 print:hidden" aria-label={section.label}>
      {tabs.map((tab) => {
        const active = tab.to === activeTo;
        return (
          <Link
            key={tab.id}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={clsx(
              '-mb-px inline-flex items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium whitespace-nowrap',
              active ? 'border-accent text-ink' : 'border-transparent text-graphite hover:text-ink',
            )}
          >
            {tab.label}
            {!!tab.badge && (
              <span className={clsx('num rounded-full px-1.5 text-[11px] font-semibold', tab.badgeTone === 'bad' ? 'bg-bad text-sheet' : 'bg-accent text-accent-ink')}>{tab.badge}</span>
            )}
          </Link>
        );
      })}
    </nav>
  );
}
